// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var LegalEntityListSettingsController = function ($scope, $routeParams, legalEntityService) {
    $scope.legalEntities = [];
    const pageSize = 20;

    if ($routeParams.parentId) {
        $scope.parentId = $routeParams.parentId;
    }
    else {
        $scope.parentId = null;
        $scope.parentEntity = null;
    }

    $scope.clearFilter = function () {
        $scope.filter = "";
        $scope.applyFilter();
    }

    $scope.applyFilter = function () {
        $scope.legalEntities = $scope.paginator(function (options, callback) {
            return legalEntityService.query(options, function () { callback(); });
        }, { search: $scope.filter, parentId: $scope.parentId }, pageSize);

        if ($scope.parentId) {
            $scope.parentEntity = legalEntityService.get({ entityId: $scope.parentId });
        }
    };

    $scope.clearFilter();

};
LegalEntityListSettingsController.$inject = ['$scope', '$routeParams', 'LegalEntities'];
